import React from "react";
import { useUboCountryRisk } from "../../../hooks/useUboCountryRisk";
import { Input } from "../../ui/Input";
import { SelectRegulatoryBody } from "../../selectors/regulatoryBody/selectRegulatoryBody";
import { SelectCountry } from "../../selectors/country/selectCountry";
import { RadioGroup } from "../../ui/RadioGroup";
import { yesNoOption } from "../../options/options";
import { MultiTextInput } from "../../ui/MultiTextInput";
export const FoundationsForm = React.memo(({renderBy, index, formData, onChange, isReadOnly, isReport}) => {
    const handleCountryChange = useUboCountryRisk(renderBy + index + "Foundations", onChange);
    return (
        <>
            <Input
                label={"Name of Foundations"}
                name={"uboFoundationName"}
                value={formData.uboFoundationName}
                disabled={isReadOnly}
                onChange={onChange}
                isReport={isReport}
                required
            />

            <Input
                label={"Principle Administrator / Trustee"}
                name={"uboPrincipleAdministrator"}
                value={formData.uboPrincipleAdministrator}
                disabled={isReadOnly}
                onChange={onChange}
                isReport={isReport}
                required
            />

            <RadioGroup
                label={"Is the Principal Administrator/ Trustee Regulated?"}
                name={"uboIsRegulated"}
                value={formData.uboIsRegulated}
                onChange={onChange}
                disabled={isReadOnly}
                options={yesNoOption}
                isReport={isReport}
                required
            />

            <SelectCountry
                label={"Country of Establishment"}
                name={"uboCountry"}
                value={formData.uboCountry}
                onChange={handleCountryChange}
                disabled={isReadOnly}
                isReport={isReport}
                required
            />

            {formData.uboIsRegulated === "Yes" && (
                <>
                    <SelectRegulatoryBody 
                        label={"Name of Regulatory Body"}
                        name={"uboRegulatoryBody"}
                        disabled={isReadOnly}
                        value={formData.uboRegulatoryBody}
                        onChange={onChange}
                        country={formData.uboCountry}
                        isReport={isReport}
                    />
                </>
                )
            }

            <Input 
                label={"Identity of the Founder"}
                name={"uboFounderIdentity"}
                disabled={isReadOnly}
                value={formData.uboFounderIdentity}
                onChange={onChange}
                isReport={isReport}
            />

            <Input
                label={"Stated purpose of the foundation"}
                name={"uboStatedPurpose"}
                disabled={isReadOnly}
                value={formData.uboStatedPurpose}
                onChange={onChange}
                isReport={isReport}
            />

            <Input 
                label={"Nature of activities"}
                name={"uboActivities"}
                disabled={isReadOnly}
                value={formData.uboActivities}
                onChange={onChange}
                isReport={isReport}
            />

            <Input 
                label={"Category of Beneficiaries"}
                name={"uboCategory"}
                disabled={isReadOnly}
                value={formData.uboCategory}
                onChange={onChange}
                isReport={isReport}
            />

            <Input 
                label={"Class of Beneficiaries"}
                name={"uboClass"}
                disabled={isReadOnly}
                value={formData.uboClass}
                onChange={onChange}
                isReport={isReport}
            />

            <MultiTextInput  
                label={"Name of beneficiaries"}
                name={"uboBeneficiaries"}
                disabled={isReadOnly}
                values={formData.uboBeneficiaries|| []}
                onChange={onChange}
                isReport={isReport}
            />

            <MultiTextInput 
                label={"Name of board member/director"}
                name={"uboBoardMembers"}
                disabled={isReadOnly}
                values={formData.uboBoardMembers|| []}
                onChange={onChange}
                isReport={isReport}
            />

        </>
    );
})